// src/config.js
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://everyounglife-back.onrender.com'
    : 'http://localhost:3000');